import Grid from 'app/grid/index';
import Modal from 'app/modal/v3/index';
import React from 'react';
import { Box, Text } from 'rebass';
import { supportedImageTypes, supportedVideoTypes } from 'stories/tell-a-story/FileDropperField';
import Warning from './Warning';

const fieldHeading = {
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '22px',
  textAlign: 'left',
  letterSpacing: '0em',
};

function InvalidFileError({ errorFiles, onDismiss, supportedTypes }) {
  if (errorFiles.length == 0) return null;

  return (
    <Modal
      maxWidth={580}
      shadeProps={{ pt: [0, 4] }}
      closeButton
      close={{ onClose: onDismiss }}
      childSx={{ marginTop: '-40px', zIndex: 1 }}
      // aboveTooltip
      closeOnOutsideClick
    >
      <Box px={2}>
        <Text
          sx={{
            fontFamily: 'Bitter',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '30px',
            lineHeight: '120%',
            color: '#000',
            textAlign: 'center'
          }}
          mb={2}
        >
          File type not supported
        </Text>

        <Warning sx={{ m: "auto" }} message={`We couldn't open ${errorFiles.map((err) => (`${err.name} `))}`} />

        <Text
          mt={2}
          sx={{
            fontFamily: 'Poppins',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '19px',
            color: '#222222',
          }}
        >
          To upload a {supportedTypes.includes('image') ? 'image' : 'video'}, please use one of these supported formats
        </Text>
        <Box justifyContent="center" my={2}>
          {supportedTypes.includes('image') && (
            <Box mt={2}>
              <Grid gridTemplateColumns="auto auto auto auto auto">
                {supportedImageTypes.map((ext) => (
                  <Text py={2} mb="0.5px" key={ext}>
                    {ext}
                  </Text>
                ))}
              </Grid>
            </Box>
          )}
          {supportedTypes.includes('video') && (
            <Box mt={2}>
              <Grid gridTemplateColumns="auto auto auto auto auto">
                {' '}
                {supportedVideoTypes.map((ext) => (
                  <Text py={2} mb="0.5px" key={ext}>
                    {ext}
                  </Text>
                ))}
              </Grid>
            </Box>
          )}

        </Box>
      </Box>
    </Modal>
  );
}

export default InvalidFileError;
